import { Component, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CurrentCustomerService } from '@common/current-customer/current-customer.service';
import { CurrentUserService } from '@common/current-user/current-user.service';
import { CustomerSelectorComponent } from '@common/customer-selector/customer-selector.component';
import { ProductTranslations } from '@common/util/products';

@Component({
    selector: 'navigation-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    providers: [],
    standalone: false
})
export class ToolbarComponent {
  public user$ = this.currentUserService.currentUser$;
  public customer$ = this.currentCustomerService.currentCustomer$;
  readonly configName = $localize`Config`;

  constructor(
    private dialog: MatDialog,
    private readonly currentCustomerService: CurrentCustomerService,
    public readonly currentUserService: CurrentUserService,
    @Inject(ProductTranslations) protected readonly products: ProductTranslations
  ) {}

  openChangeCustomerDialog() {
    this.dialog.open(CustomerSelectorComponent, { width: '500px' });
  }

  openSettings() {}
}
